import script from "./GetTheApp.vue?vue&type=script&setup=true&lang=js"
export * from "./GetTheApp.vue?vue&type=script&setup=true&lang=js"

import "./GetTheApp.vue?vue&type=style&index=0&id=48130fc3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48130fc3"]])

export default __exports__